import React from 'react';
import PropTypes from 'prop-types';
import { Mutation } from 'react-apollo';
import { FaTrash } from 'react-icons/fa';
import { DELETE_SPECIALIZATION_MAPPING } from '../queries';
import { showConfirmation } from '../ConfirmationDialogService';
import { toast } from 'react-toastify';

const getMessage = name => (
  <>
    <span>
      Permanently delete mapping of{' '}
      <strong style={{ color: 'red' }}>{name}</strong> ?
      <br />
      <br />
      <strong>THIS PROCESS IS IRREVERSIBLE!</strong>
    </span>
  </>
);

const DeleteSpecialtyMapping = ({ specialization }) => {
  const confirm = deleteMapping => {
    showConfirmation('Delete Mapping?', getMessage(specialization), () =>
      deleteMapping({
        variables: { specialization }
      })
    );
  };

  return (
    <Mutation
      mutation={DELETE_SPECIALIZATION_MAPPING}
      onCompleted={() => {
        toast.success('Mapping deleted successfully', { autoClose: 3000 });
      }}
      onError={() => {
        toast.error('Something went wrong!', { autoClose: 3000 });
      }}
      refetchQueries={() => ['GET_SPECIALIZATION_MAPPING']}
    >
      {(deleteMapping, { loading }) => (
        <span
          className="delete"
          onClick={() => !loading && confirm(deleteMapping)}
        >
          <FaTrash />
          Delete
        </span>
      )}
    </Mutation>
  );
};

DeleteSpecialtyMapping.propTypes = {
  specialization: PropTypes.string
};

export default DeleteSpecialtyMapping;
